import { render } from "./RuiTemperature.vue?vue&type=template&id=9dd24e72"
const script = {}
script.render = render

export default script